module.exports = __webpack_public_path__ + "fonts/7eac4442-f81d-41ec-8517-bbe52aecfcbf.4d777db.woff";